import { QueryClient, useQueries, useQuery } from '@tanstack/react-query'
import { getAccreditationConfig } from '../firebase/accreditation-api'
import { EmploymentSetting } from '../firebase/types-teacher'
import { mToMs } from '../helpers/utils'

export const createKey = (setting: EmploymentSetting) => {
    switch (setting.type) {
        case 'school': {
            return `${setting.locationState}:${setting.type}`
        }
        case 'supportStaff': {
            return `${setting.locationState}:${setting.type}:${setting.hasQualification}`
        }
        case 'earlyChildcare': {
            return `${setting.locationState}:${setting.type}:${setting.level}`
        }
    }
}

const useAccreditationConfig = (setting: EmploymentSetting) => {
    return useQuery({
        queryKey: [`accreditationConfig`, createKey(setting)],
        queryFn: () => getAccreditationConfig({ setting }),
        staleTime: mToMs(10),
    })
}

export const useAccreditationConfigs = (settings: EmploymentSetting[]) => {
    return useQueries({
        queries: settings.map((s) => ({
            queryKey: [`accreditationConfig`, createKey(s)],
            queryFn: () => getAccreditationConfig({ setting: s }),
            staleTime: 10000,
        })),
        combine: (results) => {
            return {
                data: settings.map((s, i) => ({
                    setting: s,
                    data: results[i].data,
                })),
                pending: results.some((el) => el.isPending),
            }
        },
    })
}

export const fetchAccreditationConfigs = (
    queryClient: QueryClient,
    setting: EmploymentSetting
) =>
    queryClient.fetchQuery({
        queryKey: [`accreditationConfig`, createKey(setting)],
    })

export default useAccreditationConfig
